import Container from '@ui/container/container';
import Button from '@ui/buttons/button/button';
import Text from '@ui/text/text/text';

interface TabRowProps<T extends string> {
  tabs: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
}

// matches Figma's underline tabs (plain text, no pill background) rather than SegmentedSwitch
export default function TabRow<T extends string>({ tabs, value, onChange }: TabRowProps<T>) {
  return (
    <Container className="flex gap-12">
      {tabs.map((tab) => {
        const isActive = tab.value === value;
        return (
          <Button
            key={tab.value}
            clear
            className="flex-column ai-flex-start padding-0"
            height="30px"
            onClick={() => onChange(tab.value)}
          >
            <Container padding="0 8px">
              <Text className="H6" color={isActive ? 'var(--global-ico-text-1)' : 'var(--global-ico-text-3)'}>
                {tab.label}
              </Text>
            </Container>
            <Container
              height="2px"
              width="100%"
              borderRadius="12px"
              margin="8px 0 0 0"
              background={isActive ? 'var(--global-ico-text-1)' : 'transparent'}
            />
          </Button>
        );
      })}
    </Container>
  );
}
